'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var icons = require('./icons.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

/* eslint-disable react/no-danger */
var MISSING_ICON = 'icon404';

var IconSvg = function IconSvg(_ref) {
  var className = _ref.className,
      icon = _ref.icon;
  var dsIcon = icons[icon] || icons[MISSING_ICON];
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: "icon ic-".concat(icon, " ").concat(className),
    viewBox: dsIcon.viewBox
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    dangerouslySetInnerHTML: {
      __html: dsIcon.path
    }
  }));
};

IconSvg.propTypes = {
  className: PropTypes__default['default'].string,
  icon: PropTypes__default['default'].string.isRequired
};
IconSvg.defaultProps = {
  className: ''
};

module.exports = IconSvg;
